import React from 'react'
import { Link } from 'react-router-dom'

const BookRideSection = () => {
    return (
        <>
            <section className="booRide_wrap section_pt section_pb">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-12 col-12">
                            <div className="work_left">
                                <h2 className="text-dark wow fadeInLeft" data-wow-duration="1s">Book Your Ride <br /> With
                                    <b><i>Orbi</i></b>
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-12">
                            <div className="store_detail wow fadeInRight" data-wow-duration="1s">
                                <div className="app_links">
                                    <Link to="#"
                                        onClick={(e) => e.preventDefault()} data-bs-toggle="modal" data-bs-target="#playStoreModal">
                                        <img src="/assets/img/all-images/android-btn.png" alt="Download on Google Play" /></Link>
                                    <Link to="#"
                                        onClick={(e) => e.preventDefault()} data-bs-toggle="modal" data-bs-target="#appStoreModal">
                                        <img src="/assets/img/all-images/apple-btn.png" alt="Download on the App Store" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BookRideSection